import React from 'react';

import classNames from 'classnames';

export interface ButtonGroupProps {
  className?: string;
  children?: React.ReactNode;
}

export const ButtonGroup = ({ className, children }: ButtonGroupProps) => {
  return (
    <div className={classNames('flex grow items-center justify-end gap-2', className)}>
      {children}
    </div>
  );
};
